export default __webpack_public_path__ + "static/media/03_bath_m.5878f8aa.webp";